import React, { useEffect, useMemo, useRef, useState } from "react";
import "../../../css/Dropdown/EmailFilterDropdown.css";
import { ReactComponent as Arrowdown } from "../../../assets/icons/arrow-down.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";

export default function EmailFilterDropdown({
  options = [],
  value = "",
  onChange,
  placeholder = "Select email",
  disabled = false,
}) {
  const wrapperRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const selectedOption = useMemo(
    () => options.find((opt) => opt.value === value),
    [options, value],
  );

  const filteredOptions = useMemo(() => {
    const q = (search || "").trim().toLowerCase();
    if (!q) return options;
    return options.filter((opt) => (opt.label || "").toLowerCase().includes(q));
  }, [options, search]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const handleSelect = (selectedValue) => {
    onChange?.({
      target: {
        value: selectedValue,
      },
    });
    setOpen(false);
    setSearch("");
  };

  const handleClear = (e) => {
    e.stopPropagation();
    handleSelect("");
  };

  return (
    <div
      ref={wrapperRef}
      className={`AML-Email-Dropdown ${disabled ? "is-disabled" : ""}`}
    >
      <button
        type="button"
        className="AML-Email-Dropdown-Trigger AML-Text-Body"
        onClick={() => !disabled && setOpen((prev) => !prev)}
      >
        <span className="AML-Email-Dropdown-Label AML-Text-Body">
          {selectedOption?.label || placeholder}
        </span>

        <div className="AML-Email-Dropdown-Actions">
          {value && (
            <span
              className="AML-Email-Dropdown-Clear"
              onClick={handleClear}
              role="button"
              tabIndex={0}
              aria-label="Clear selected email"
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleClear(e);
                }
              }}
            >
              <CloseIcon />
            </span>
          )}

          <span className={`AML-Email-Dropdown-Arrow ${open ? "is-open" : ""}`}>
            <Arrowdown />
          </span>
        </div>
      </button>

      {open && (
        <div className="AML-Email-Dropdown-Menu">
          <div className="AML-Email-Dropdown-SearchWrap">
            <input
              type="text"
              className="AML-Email-Dropdown-Search"
              placeholder="Search email..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="AML-Email-Dropdown-Options">
            <div
              className={`AML-Email-Dropdown-Option ${
                value === "" ? "is-selected" : ""
              } Content-Small`}
              onClick={() => handleSelect("")}
            >
              All emails
            </div>

            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt) => (
                <div
                  key={opt.value}
                  className={`AML-Email-Dropdown-Option ${
                    value === opt.value ? "is-selected" : ""
                  } Content-Small`}
                  onClick={() => handleSelect(opt.value)}
                >
                  {opt.label}
                </div>
              ))
            ) : (
              <div className="AML-Email-Dropdown-Empty">No emails found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
